export const urlParam = function(name){
    var results = new RegExp('[?&]' + name + '=([^#]*)').exec(window.location.href);
    if (results==null){
        return null;
    }
    else{
        return results[1].split('&')[0] || 0;
    }
}